/*
Copyright (c) 2010 Robert Kieffer
Dual licensed under the MIT and GPL licenses.
Source: http://www.broofa.com/Tools/Math.uuid.js
*/
const uuidTemplate = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
const allPatternChars = /[xy]/g
const intoUUIDChar = (c: string) => {
  const r = (Math.random() * 16) | 0
  const v = c === 'x' ? r : (r & 0x3) | 0x8
  return v.toString(16)
}
export const uuid = (): string => uuidTemplate.replace(allPatternChars, intoUUIDChar)
